import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgrxFormsModule } from 'ngrx-forms';

import { SharedNgrxFormsModule } from '@sd-portal/shared/ngrx-forms';

// state
import { USER_CONFIGURATION_MODULE_KEY } from './+state/user-configuration.declarations';
import { reducers } from './+state';
// effects
import { CalendarConfigurationEffects } from './+state/calendar-configuration/calendar-configuration.effects';
import { UserConfigurationEffects } from './+state/user-configuration.effects';
// facades
import { CalendarConfigurationFacade } from './+state/calendar-configuration/calendar-configuration.facade';
import { UserConfigurationFacade } from './+state/user-configuration.facade';
// services
import { SharedUserConfigurationService } from './shared-user-configuration.service';
// components
import { CalendarConfigurationDialogComponent } from './calendar-configuration-dialog/calendar-configuration-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSelectModule,
    NgrxFormsModule,
    SharedNgrxFormsModule,
    StoreModule.forFeature(USER_CONFIGURATION_MODULE_KEY, reducers),
    EffectsModule.forFeature([CalendarConfigurationEffects, UserConfigurationEffects])
  ],
  declarations: [CalendarConfigurationDialogComponent],
  providers: [SharedUserConfigurationService, UserConfigurationFacade, CalendarConfigurationFacade]
})
export class SharedUserConfigurationModule {}
